<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="verify"
    @keypress.enter="verify"
  >
    <p class="text-justify mb-5">
      Caso você esteja aqui pela primeira vez comprando ingressos conosco e por este motivo ainda não tenha um cadastro
      em nossa base, prossiga informando seu documento no campo abaixo:
    </p>

    <v-row justify="center">
      <v-col cols="12" sm="4">
        <v-select
          v-model="user.form.model.document_type"
          :items="documentTypeItems"
          variant="outlined"
          hide-details
          class="mb-4"
          @update:model-value="user.form.model.document = ''"
        />
      </v-col>
      <v-col cols="">
        <t-document-input
          v-model="user.form.model.document"
          :document-type="user.form.model.document_type"
          required
        />
      </v-col>
    </v-row>

    <t-btn
      block
      color="success"
      type="submit"
      class="heading--text"
      large
      :loading="loader.loading('button')"
      :disabled="!valid"
    >
      Cadastrar
    </t-btn>
  </v-form>
</template>

<script setup lang="ts">
import { ref, useTemplateRef, type Ref } from "vue";
import userExists from "@/api/requests/userExists";
import TBtn from "@/components/core/TBtn.vue";
import TDocumentInput from "@/components/core/TDocumentInput.vue";
import { useUserStore } from "@/stores/user";
import { useLoader } from "@/stores/loader";
import { useSnackbar } from "@/stores/snackbar";

const documentTypeItems = [
  { title: "CPF", value: "cpf" },
  { title: "Passaporte", value: "passport" },
];

const user = useUserStore();
const snackbar = useSnackbar();
const loader = useLoader();

const emit = defineEmits<{
  verified: [exists: boolean];
}>();

defineOptions({
  name: "FormVerifyUser",
});

const form = useTemplateRef<{ validate: () => boolean }>("form");

const valid: Ref<boolean> = ref(true);

async function verify(): Promise<void> {
  if (!form.value?.validate()) return;

  try {
    loader.increment("button");
    const exists = await userExists("document", user.form.model.document);
    emit("verified", exists);
  } catch (e) {
    snackbar.error(e);
  } finally {
    loader.decrement("button");
  }
}
</script>
